import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/pt-br'
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false
Vue.use(Element, { locale })

Raven
  .config(process.env.VUE_APP_SENTRY_DSN)
  .addPlugin(RavenVue, Vue)
  .install()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
